<template>
  <div>
    <div class="row justify-content-center">
      <div class="col-md-12 mb-3">
        <div>
          <step-progress
            :steps="mySteps"
            :current-step="currentStep"
            icon-class="fa fa-check"
            active-color="#c698fa"
          ></step-progress>
        </div>
      </div>
      <div class="col-md-12 mb-3">
        <b-button
          variant="secondary"
          @click="prevClick"
          class="mr-3"
        ><i
            class="fas fa-chevron-left text-grey"
            aria-hidden="true"
          ></i></b-button>

      </div>
      <div class="col-md-12 mb-4"  v-if="isAbleAnonymous">
        <b-jumbotron>
          <template v-slot:header>Non-Member</template>
        </b-jumbotron>
      </div>
      <div class="col-md-12 mb-4"  v-else>
        <b-jumbotron>
          <template v-slot:header>Select Member</template>

          <template v-slot:lead>
            Please add new member or select member to this package.
          </template>
          <div class="row mb-5 mt-5">
            <div class="col-md-5">
              <div class="d-flex justify-content-center">
                <b-button
                  size="lg"
                  variant="primary"
                  @click="showModal"
                >Create New Member</b-button>
              </div>
            </div>
            <div class="col-md-2">
              <span class="d-flex justify-content-center">
                - OR -
              </span>
            </div>
            <div class="col-md-5">
              <div class="d-flex justify-content-center">
                <div class="input-group">
                  <input
                    @keyup="checkinSearch"
                    class="form-control"
                    type="text"
                    id="memberSearchInput"
                    name="memberSearchInput"
                    v-model="memberSearchInput"
                    placeholder="Search member ID, name, or phone.."
                    aria-label="Search member ID, name, or phone.."
                  />
                  <div class="input-group-append">
                    <span
                      class="input-group-text pl-4 pr-4"
                      id="searchbtt"
                      @click.prevent="checkinSearch"
                    ><i
                        class="fas fa-search text-grey"
                        aria-hidden="true"
                      ></i></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12 mt-4">
              <div>
                <h5 v-if="isSearch">Search Result:</h5>
                <sale-member-table
                  v-if="isSearch"
                  :memberResult="memberResult"
                  v-on:member-created="memberCreated"
                ></sale-member-table>
              </div>
              <!--<test-table></test-table>-->
            </div>
          </div>
          <hr class="my-4" />
          <div
            v-if="selectMember != null"
            class=" inline-block"
          >
            <h3 class="">
              Selected Member: {{ selectMember.firstname }}
              {{ selectMember.lastname }}
              <small><a
                  href="#"
                  @click.prevent="removeMember"
                >Remove</a></small>
            </h3>
          </div>

          <h3 v-else>Selected Member: --</h3>
        </b-jumbotron>
      </div>
    </div>
    <div
      class="d-flex justify-content-center"
      v-if="selectMember != null"
    >
      <b-button
        size="lg"
        variant="primary"
        block
        @click.prevent="memberSubmit"
      >Next</b-button>
    </div>
    <div
      class="d-flex justify-content-center"
      v-if="isAbleAnonymous && selectMember == null"
    >
      <b-button
        size="lg"
        variant="warning"
        block
        @click.prevent="anonymousSubmit"
      >Walk In</b-button>
    </div>
    <modals-container name="member_create_modal" />
  </div>
</template>
<script>
import Vue from "vue";
import StepProgress from "vue-step-progress";
import "vue-step-progress/dist/main.css";
import SaleMemberTable from "./SaleMemberTable.vue";
import MemberCreate from "./MemberCreate.vue";
import VModal from "vue-js-modal";
Vue.use(VModal, { dynamic: true, dynamicDefaults: { clickToClose: true } });

export default {
  data() {
    return {
      loading: false,
      isSearch: false,
      memberSearchInput: null,
      memberResult: null,

      mySteps: ["Package", "Member", "Payment", "Complete"],
      currentStep: 1,
      selectType: null,
      selectDuration: null,
      selectMember: null
    };
  },
  created() {
    this.loading = true;
  },
  components: {
    "step-progress": StepProgress,
    SaleMemberTable
  },
  computed: {
    isAbleAnonymous() {
      const duration = ["1D", "5D", "1S","10D","20D"];
      if (duration.includes(this.$store.getters.getSalePackage.duration)) {
        return true;
      }
      return false;
    }
  },
  methods: {
    prevClick() {
      this.$store.dispatch("setSaleState", 0);
    },
    async checkinSearch() {
      //console.log(this.memberSearchInput);

      if (
        this.memberSearchInput == "" ||
        this.memberSearchInput == null ||
        this.memberSearchInput.length < 2
      ) {
        return false;
      }

      this.isSearch = false;
      await axios
        .get("/api/members/find", {
          params: {
            keysearch: this.memberSearchInput
          }
        })
        .then(response => {
          //console.log(response.data);
          this.memberResult = response.data;

          //console.log(response.data.data);
          this.loading = false;
          this.isSearch = true;
        });
    },
    showModal() {
      this.$modal.show(
        MemberCreate,
        {
          //--- Component property
          passtext: "This text is passed as a property"
          //selfmodal: this.$modal,
        },
        {
          //-- Modal Params
          draggable: false,
          height: "auto",
          scrollable: true,
          adaptive: true
        },
        {
          //-- Modal event listener
          "before-close": event => {
            //console.log(event);
            if (this.$store.getters.getSaleMember != null) {
              this.selectMember = this.$store.getters.getSaleMember;
              this.isSearch = false;
            }

            //console.log(this.$store.getters.getSaleMember);

            //console.log("this will be called before the modal closes");
          },
          "before-open": event => {
            //console.log("this will be called before the modal open");
          }
        },
        {}
      );
    },
    memberCreated(data) {
      this.$store.dispatch("setSaleMember", data);
      //console.log(data.email);
      this.selectMember = data;
      this.isSearch = false;
      //console.log(this.selectMember);
    },
    removeMember() {
      this.$store.dispatch("setSaleMember", null);
      this.selectMember = null;
    },
    memberSubmit() {
      this.$store.dispatch("setSaleState", 2);
    },
    anonymousSubmit() {
      this.$store.dispatch("setSaleMember", null);
      this.selectMember = null;
      this.$store.dispatch("setSaleState", 2);
    }
  }
};
</script>
<style scoped>
#searchbtt {
  cursor: pointer;
}
small {
  font-size: 0.5em;
}
</style>
<style src="vue-step-indicator/dist/vue-step-indicator.css"></style>
